import { useEffect, useMemo, useState } from "react";

import { usePlotPlans } from "@/sx-layout/components/settings/plotPlanSetting/hooks/usePlotPlans";
import { useMapImageApi } from "@/sx-layout/hooks/useMapImageApi";

export const usePlotPlanImage = (plotPlanId: number | undefined) => {
  const mapImageApi = useMapImageApi();
  const { plotPlans } = usePlotPlans();

  const [mapImageBlob, setMapImageBlob] = useState<Blob>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!plotPlanId) {
      setMapImageBlob(undefined);
      return;
    }

    const plotPlan = plotPlans.find(
      (p) => p.plot_plan_id === plotPlanId || String(p.plot_plan_id) === String(plotPlanId)
    );
    // 画像読み込み
    if (plotPlan && plotPlan.map_image_id) {
      setLoading(true);
      mapImageApi.fetchMapImage(plotPlan.map_image_id).then((blob) => {
        setLoading(false);
        setMapImageBlob(blob);
      });
    }
  }, [plotPlanId]);

  const mapImageUrl = useMemo(() => {
    if (!mapImageBlob || !(mapImageBlob instanceof Blob)) return "";

    return URL.createObjectURL(mapImageBlob);
  }, [mapImageBlob]);

  // URLのメモリリークを防ぐためのクリーンアップ
  useEffect(() => {
    return () => {
      if (mapImageUrl) {
        URL.revokeObjectURL(mapImageUrl);
      }
    };
  }, [mapImageUrl]);

  return { mapImageUrl, loading };
};
